import $ from 'jquery';
import run from '../../utilities/run';
require("../stubs/amazonLPNInfo/amazonLPNInfo.less");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
run("#amazon-fba-carton-info", ()=>{
  main("#amazon-fba-carton-info");
});

function main(targetSelector){
  const mainEl = $(targetSelector);
  const approveOverrideBtn = mainEl.find('.approve-override-btn');
  const modal = $('#supervisor-approval-override-modal');
	let override = false;
	const errorFlow = new SubmitModalFlow;
	errorFlow.init();
  modal.modal({
    show: false
  });

  $('#overide-success-msg').hide();

  if ($('#send-carton-mismatch-msg').length > 0) {
    $('#no-problems-msg-section').hide();
    $('#send-carton-to-amazon').hide();
    $('#qty-all-match-badge').hide();
  }

  approveOverrideBtn.on('click', function(e){
    e.preventDefault();
    showSupervisorModal();
  });

  function showSupervisorModal(){
    modal.modal("show");
  }
  
  $('#send-carton-to-amazon a').click(function(e){
  	e.preventDefault();
  	$('#loading-screen-mask').removeClass('hide');

    if(!($("#resend-carton-to-amazon").hasClass("hide"))) {
      $("#resend-carton-to-amazon").addClass('hide');
    }

  	$(this).parent().addClass('hide');
  	$.ajax({
  		url: mainEl.data("send-carton-url"),
  		type: 'POST',
  		dataType: 'JSON',
  		data: {
  			palletNumber: mainEl.data("pallet-number"),
  			orderId: mainEl.data("order-id"),
				shipmentId: mainEl.data("shipment-id"),
				doNumber: mainEl.data("do-number"),
  			feedSubmissionId: $('#feedSubmissionId').val(),
        override: override
  		},
  		success: function(response){
  			$('#loading-screen-mask').addClass('hide');
  			$('#feedSubmissionId').val(response.feedSubmissionId);
  			if(response.status == 'success'){
  				window.location = mainEl.data("scan-lpn-url");
  			}else if(response.status == 'ERROR'){
          $('#no-problems-msg-section').hide();
  				$('#connection-timeout-message').removeClass('hide');
  				$("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
  				$('#resend-carton-to-amazon').removeClass('hide');
  			}else{
          $('#no-problems-msg-section').hide();
  				$('#send-carton-error-response').removeClass('hide');
          $('#connection-timeout-message').addClass('hide');
  				$("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
  				$('#resend-carton-to-amazon').removeClass('hide');
  			}
  		},
  		error: function(){
        $('#no-problems-msg-section').hide();
        $('#loading-screen-mask').addClass('hide');
  			$('#send-carton-error-response').removeClass('hide');
        $("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
        $('#resend-carton-to-amazon').removeClass('hide');
  		}
  	});
  });
  
  $('#resend-carton-to-amazon a').click(function(e){
  	e.preventDefault();
  	$('#send-carton-to-amazon a').trigger('click');  
  });
  
  $('#approve-override-submit-btn').click(function(e){
	e.preventDefault();
	$('#invalid-credentials-message').addClass('hide');
	$('#no-permission-override-message').addClass('hide');
	$.ajax({
		url: mainEl.data("approve-override-url"),
		type: 'POST',
		dataType: 'html',
		data: {
			palletNumber: mainEl.data("pallet-number"),
			orderId: mainEl.data("order-id"),
			overrideLoginUser: $('#overrideLoginUser').val(),
			overrideLoginPwd: $('#overrideLoginPwd').val()
		},
		success: function(data){
			if(data == 'success'){
				modal.modal("hide");
        $('#mismatch-error-msg').hide();
        $('.approve-override-btn').hide();
        $('#send-carton-mismatch-msg').hide();
        $('#qty-mismatch-badge').hide();
        $('#no-problems-msg-section').show();
        $('#qty-all-match-badge').show();
        $('#overide-success-msg').show();
        $('#send-carton-to-amazon').show();
        $('.q-pill-red').each(function(i, obj) {
          $(this).removeClass();
        });
        override = true;
			}else if(data == 'Authentication failed'){
				$('#invalid-credentials-message').removeClass('hide');
			}else if(data == 'No supervisor role is assigned'){
				$('#no-permission-override-message').removeClass('hide');
			}else{
				errorFlow.showFailureModal();
			}
		},
		error: function(){
			errorFlow.showFailureModal();
		}
	});
  });
  
};


// WEBPACK FOOTER //
// ./src/pages/amazon-fba-order/amazonLPNInfo.js